module.exports = __webpack_public_path__ + "static/media/tti_avg_time_to_transfer@3x.401abcfa.png";